// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/FireProtection.tsx

import HeroParallax from "../../components/HeroParallax.tsx";
import Counter from "../../components/Counter.tsx";
import Showcase from "../../components/Showcase.tsx";
import PartnerGrid from "../../components/PartnerGrid.tsx";
import CareersBanner from "../../components/CareersBanner.tsx";
import ESG from "../../components/ContentCard.tsx";
import ContactPerson from "../../components/ContactPerson.tsx";
import AnchorMenu from "../../components/AnchorMenu.tsx";
import { useLanguage } from "../../lang/index.lang.tsx";

const FireProtection = () => {
  const { t } = useLanguage();

  return (
    <>
      <AnchorMenu
        title={t("services.fire-protection.title")}
        titleLink="#services"
        items={[      
          { id: "Title", label: t("counter.heading.title"), anchor: "Counter" },    
          { id: "2", label: t("anchor.whatWeDo"), anchor: "AllServices" },          
          { id: "3", label: t("navigation.career"), anchor: "Careers" },
          { id: "4", label: t("services.heading.partner"), anchor: "Partner" },     
          { id: "5", label: t("anchor.contactPersons"), anchor: "ContactPersons" },
          { id: "6", label: t("home.esg.heading.subtitle"), anchor: "esg" },    
          
        ]}
      />

      

      <section id="Services">
      <HeroParallax        
        header={t("services.fire-protection.header")}
        welcome={t("services.fire-protection.welcome")}
        title={t("services.fire-protection.description.short")}
        description={t("services.fire-protection.description.long")}
        buttonText={t("common.learnMore")}
        buttonLink=""
        image="/images/EST-124997846.jpg"
      />
    </section>

      <section id="Counter">
      <Counter 
        items={[
          {
            key: "buildingPeriod",
            endValue: 30,
            prefix: "-",
            suffix: "%",
          },
          {
            key: "buildingVolume",
            endValue: 100,
            prefix: "",
            suffix: " Mio.€",
          },
          {
            key: "realizedProjects",
            endValue: 200,
            prefix: "",
            suffix: "+",
          },
          {
            key: "realizedSquareMeters",
            endValue: 75000,
            prefix: "",
            suffix: "+",
          },
        ]}
        sectionTitle={t("services.fire-protection.title")}
        mainTitle={t("counter.heading.title")}
      />
      </section>

      

      <section id="AllServices">
        <Showcase
          heading={{
            subtitle: t("services.fire-protection.title"),
            title: t("services.fire-protection.header"),
            explore: t("services.fire-protection.explore"),
          }}        
          items={[   
            {
              id: 1,
              title: t("services.fire-concepts.title"),
              subtitle: t("services.fire-concepts.description.short"),
              description: t("services.fire-concepts.description.long"),
              link: "",
            },         
            {
              id: 2,
              title: t("services.fire-regulations.title"),
              subtitle: t("services.fire-regulations.description.short"),
              description: t("services.fire-regulations.description.long"),
              link: "",
            },            
            {
              id: 3,
              title: t("services.fire-safety-officers.title"),
              subtitle: t("services.fire-safety-officers.description.short"),
              description: t("services.fire-safety-officers.description.long"),
              link: "",
            },
            {
              id: 4,
              title: t("services.fire-construction-supervision.title"),
              subtitle: t("services.fire-construction-supervision.description.short"),
              description: t("services.fire-construction-supervision.description.long"),
              link: "",
            },          
          ]}        
          learnMoreText={t("services.heading.learnMore")}
        />
      </section>

      <section id="Careers">
        <CareersBanner
          image="/images/EST-6372937.jpg"
          title={t("home.heroBanner.title")}
          description={t("home.heroBanner.description")}
          buttonText={t("home.heroBanner.buttonText")}
          buttonLink="/careers"
        />
      </section>

      <section id="Partner">
        <PartnerGrid />
      </section>

      <section id="ContactPersons">
        <ContactPerson
          heading={{
            subtitle: t("services.fire-protection.department"),
            title: t("services.heading.contact-person"),
          }}
          employeeIds={["AS"]}
        />
      </section>

      <section id="esg">
        <ESG
          heading={{
            title: t("home.esg.heading.title"),    
            description: t("home.esg.heading.description"),       
          }}
          data={[
            {
              id: 1,
              title: t("home.esg.s.title"),
              description: t("home.esg.s.description"),
              image: "/images/EST-1385648186.jpg",
              category: t("home.esg.s.category"),
              buttonText: t("home.esg.s.buttonText"),
              buttonLink: "/about",
            },
            {
              id: 2,
              title: t("home.esg.e.title"),
              description: t("home.esg.e.description"),
              image: "/images/EST-599972772.jpg",
              category: t("home.esg.e.category"),
              buttonText: t("home.esg.e.buttonText"),
              buttonLink: "/about",
            },          
            {
              id: 3,
              title: t("home.esg.g.title"),
              description: t("home.esg.g.description"),
              image: "/images/EST-12499784456.jpg",
              category: t("home.esg.g.category"),
              buttonText: t("home.esg.g.buttonText"),
              buttonLink: "/about",
            },          
          ]}
        />
      </section>

      
    </>
  );
};

export default FireProtection;
